export default {
  "en": {
    "todo_list": {
      "actions": {
        "add": "Create Task List",
        "cancel": "Undo",
        "delete_todo_list": "Delete List",
        "edit": "Edit Task List",
        "new": "New Task List",
        "save": "Save",
        "title": "List title"
      },
      "attributes": {
        "name": "Title"
      },
      "labels": {
        "assignToLevel": "Assign to level",
        "newTodoList": "New Task List"
      },
      "placeholders": {
        "employees": {
          "new": {
            "subtitle": "Keep an overview of what you and your team have to do.",
            "title": "Open a new Task List"
          }
        }
      },
      "toasts": {
        "create": "Task list successfully created",
        "delete": "Task list has beens successfully deleted",
        "update": "Task list has been successfully updated"
      },
      "validation": {
        "needTitle": "Title required"
      }
    }
  }
}